import { sql, type SQLWrapper } from "drizzle-orm";
import { foreignKey, pgTable, timestamp, uniqueIndex, varchar } from "drizzle-orm/pg-core";
import { organisations, students, users } from "./schemaBase.js";

/** Prevent address matching from silently restoring an owner-removed link. */
export const studentAccountAccessBlocks = pgTable("student_account_access_blocks", {
  id: varchar("id").default(sql`gen_random_uuid()`).primaryKey(),
  organisationId: varchar("organisation_id").notNull(),
  studentId: varchar("student_id").notNull(),
  userId: varchar("user_id").notNull(),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, (table) => [
  uniqueIndex("student_account_access_blocks_identity").on(table.organisationId, table.studentId, table.userId),
  foreignKey({ name: "student_account_access_blocks_org_fk", columns: [table.organisationId], foreignColumns: [organisations.id] }),
  foreignKey({ name: "student_account_access_blocks_student_fk", columns: [table.studentId], foreignColumns: [students.id] }),
  foreignKey({ name: "student_account_access_blocks_user_fk", columns: [table.userId], foreignColumns: [users.id] }),
]);

export function accountAccessNotBlocked(organisationId: string, studentId: SQLWrapper | string, userId: SQLWrapper | string) {
  return sql`not exists (select 1 from ${studentAccountAccessBlocks}
    where ${studentAccountAccessBlocks.organisationId} = ${organisationId}
      and ${studentAccountAccessBlocks.studentId} = ${studentId}
      and ${studentAccountAccessBlocks.userId} = ${userId})`;
}
